import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChildren,
} from "@angular/core";

import { map, flatten } from "lodash";

@Component({
  selector: "panel",
  templateUrl: "./panel.component.html",
  styleUrls: ["./panel.component.scss"],
})
export class PanelComponent implements OnInit {
  @Input()
  custId;

  @Input()
  metadata;

  @Input()
  level;

  @Input()
  entityId;

  @Input()
  studentFirstName;

  @Input()
  role;

  @Input()
  hasAllSchools;

  @Input()
  schoolMinGradeLevel;

  @Input()
  tier;

  @Input()
  filterCategory;

  @Input()
  filterValue;

  @Input()
  useRealTimeSchoolProfileRequest: boolean = false;

  @Output() clearFilterEvent = new EventEmitter<any>();
  @ViewChildren("Tile") tiles: any;

  hasStudentKpis;

  constructor() {}

  ngOnInit() {
    if (this.level === "student") {
      let studentKpiArrays = map(this.metadata.tiles, "studentKPIs");
      this.hasStudentKpis = flatten(studentKpiArrays).length > 0;
    }
  }

  trackByTileFn(index) {
    return index;
  }

  resetChartsToOverall() {
    this.tiles.forEach((tile) => {
      tile.resetChartsToOverall();
    });
  }
}
